define('libs/dialog.manager',['require','libs/utilities.element.getdimensions','TweenLite','TweenLiteCSS','libs/dialog','libs/overlay'],function(require) {

    'use strict';

    var _getDimensions = require('libs/utilities.element.getdimensions'),
        _tween = require('TweenLite'),
        _tween_css = require('TweenLiteCSS'),
        _dialog = require('libs/dialog'),
        //_dialog_ajax = require('components/dialog.ajax'),
        _overlay = require('libs/overlay');

    var DialogManager = function(/*app*/) {
        this.overlay = _overlay.getInstance();
        //this.app = app;
        this.initEvents();

        this.isBlocked = false;
    };

    /**
     * Bind dialog functionality to a bunch of events
     */
    DialogManager.prototype.initEvents = function() {
        var $body = $(document.body),
            $doc = $(document);

        $body.on('click', 'a.dialogify', this.tryShow.bind(this));
        $body.on('click', 'button.dialogify', this.tryShow.bind(this));

        //$body.on('submit', this.trySubmitShow.bind(this), 'form.dialogify');

        $body.on('click', '.dialog .close', this.tryHide.bind(this));
        $doc.on('click', '#overlay', this.tryHide.bind(this));
        $doc.on('keyup', this.tryHide.bind(this));
    };

    /**
     * Handle clicks on links that open a dialog.
     * @param {Event} event The click event.
     */
    DialogManager.prototype.tryShow = function(event) {
        if (this.isBlocked) {
            return;
        }

        var rel = event.currentTarget.getAttribute('rel'),
            dialog;

        if (rel) {
            event.preventDefault();
            var $element = $(rel);
            if ($element.length) {
                // look for already existing instance of the dialog class and use it if present.
                dialog = $element.data('dialog_instance');
                if (!dialog) {
                    dialog = new _dialog($element[0], {
                        destroyOnHide: false
                    });
                    $element.data('dialog_instance', dialog);
                }
            }
        }
        //else {
        //    // load dialog content with an ajax request.
        //    var url = event.currentTarget.getAttribute('data-url') || event.currentTarget.getAttribute('href');
        //    if (url && url !== '#') {
        //        event.preventDefault();
        //        dialog = new _dialog_ajax(url, {
        //            destroyOnHide: true,
        //            centered: true,
        //            originalEvent: event,
        //            app: this.app
        //        });
        //    }
        //}

        if (dialog) {
            this.show(dialog, event);
        }
    };

    /**
     * Handle submit of a form that should display it's result in a dialog.
     * @param {Event} event The submit event.
     */
    //DialogManager.prototype.trySubmitShow = function(event) {
    //    event.preventDefault();
    //
    //    if (this.isBlocked) return;
    //
    //    var dialog = new _dialog_ajax(event.selectedTarget, {
    //        destroyOnHide: true,
    //        centered: true,
    //        originalEvent: event,
    //        app: this.app
    //    });
    //
    //    this.show(dialog, event);
    //};


    /**
     * Display a selected dialog.
     */
    DialogManager.prototype.show = function(dialog, event) {

        var haveCurrentDialog = !!this.currentDialog;
        if (this.currentDialog) {
            this.currentDialog.hide();
        }

        // show the overlay.
        this.overlay.show(this, 'dialog');

        // show the dialog and save it as the current dialog.
        this.currentDialog = dialog;
        this.currentDialog.show(event, haveCurrentDialog);

        $(this.currentDialog.root).on(_dialog.EVENTS.showComplete, this.dialogShowCompleteHandler.bind(this));
        this.isBlocked = true;
    };

    DialogManager.prototype.dialogShowCompleteHandler = function(event) {
        var dialog = event.target;
        $(dialog).off(_dialog.EVENTS.showComplete);

        this.isBlocked = false;
    };

    /**
     * Handle various events that should potentially cause the
     * current dialog to close.
     */
    DialogManager.prototype.tryHide = function(event) {
        event && event.preventDefault && event.preventDefault();

        if (this.isBlocked) return;

        switch (event.type) {
            case 'click':
            case 'overlay.click':
                this.hide();
                break;

            case 'keyup':
                if (event.keyCode === 27) {
                    this.hide();
                }
                break;
        }
    };

    /**
     * Hide the current dialog if any.
     */
    DialogManager.prototype.hide = function(event, keepOverlay) {

        event && event.preventDefault && event.preventDefault();

        if (this.currentDialog) {
            this.currentDialog.hide();
            this.currentDialog = null;
        }

        if (!keepOverlay) {
            this.overlay.hide(this);
        }
    };

    return DialogManager;
});

